module.exports = __webpack_public_path__ + "static/media/500.a8fda79a.svg";